import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import { useAemConfig } from '@as-react/common-components';
import { ABTestCookie, } from '@as-react/common-types';
import { useIsClient } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { MobileNavigation } from '../components/navigation/mobile-navigation/MobileNavigation';
import { useCategoryHierarchyTree } from '../hooks/useCategoryHierarchyTree';
import { getDefaultNavigationLevel, getMobileNavigationData } from '../util/MobileNavigation.util';
import { useABTest } from '../hooks/useABTest';
import { EventEnum } from '@as-react/common-types';
import { useForceUpdate } from '../hooks/useForceUpdate';
const MobileNavigationContainer = ({ menuConfiguration, currencies, enableABTest, searchConfig, accountConfig, }) => {
    var _a;
    const forceUpdate = useForceUpdate();
    const { t } = useTranslation([I18N_NAMESPACES.general, I18N_NAMESPACES.navigation]);
    const { categoryIds, categoryHierarchyTree } = useCategoryHierarchyTree();
    const { hasBCookie: mobileNavigationABTest } = useABTest(ABTestCookie.MOBILE_NAVIGATION);
    const isClient = useIsClient();
    const { lang } = useAemConfig();
    const navigationData = useMemo(() => getMobileNavigationData(menuConfiguration, t(`${I18N_NAMESPACES.navigation}:navigation.home`)), [menuConfiguration]);
    useEffect(() => {
        if (!isClient && mobileNavigationABTest) {
            return;
        }
        window.addEventListener(EventEnum.TARGET_MOBILE_NAV_DEPLOYED, forceUpdate);
        return () => window.removeEventListener(EventEnum.TARGET_MOBILE_NAV_DEPLOYED, forceUpdate);
    }, [isClient, mobileNavigationABTest]);
    if (!navigationData)
        return null;
    if (enableABTest) {
        if (mobileNavigationABTest && isClient) {
            const navigationTrigger = document.querySelector('.as-o-menu--state-toggle__backdrop');
            if (navigationTrigger) {
                const navigationCheckbox = document.getElementById('main-menu-toggle');
                const menuIcon = navigationTrigger.querySelector('.as-a-icon');
                navigationTrigger.removeAttribute('for');
                menuIcon.style.display = 'none';
                if (navigationCheckbox === null || navigationCheckbox === void 0 ? void 0 : navigationCheckbox.checked) {
                    (_a = window.navigationMobileMenuEnhancerToggleOff) === null || _a === void 0 ? void 0 : _a.call(window);
                    navigationCheckbox.checked = false;
                }
                return createPortal(_jsx(MobileNavigation, { isABTestEnabled: true, accountConfig: accountConfig, searchConfig: searchConfig, menuItems: navigationData, currencies: currencies, defaultLevel: getDefaultNavigationLevel(categoryHierarchyTree, categoryIds, lang, navigationData) }), navigationTrigger);
            }
        }
        return null;
    }
    return (_jsx(MobileNavigation, { searchConfig: searchConfig, accountConfig: accountConfig, menuItems: navigationData, currencies: currencies, defaultLevel: getDefaultNavigationLevel(categoryHierarchyTree, categoryIds, lang, navigationData) }));
};
export default MobileNavigationContainer;
